import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { backupsApi } from "./client";

export const backupStatusQueryKey = ["backups", "status"] as const;

export function useBackupStatusQuery(enabled: boolean) {
  return useQuery({
    queryKey: backupStatusQueryKey,
    queryFn: () => backupsApi.getStatus(),
    enabled,
    staleTime: 60_000,
  });
}

export function useDownloadDatabaseBackupMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => backupsApi.downloadDatabase(),
    onSuccess: async () => {
      toast.success("ດາວໂຫຼດ backup ສຳເລັດ", {
        description: "ເກັບໄຟລ໌ໄວ້ນອກເຊີຟເວີ ແລະ ຢ່າແຊร์ໃຫ້ຄົນອື່ນ.",
      });
      await queryClient.invalidateQueries({ queryKey: backupStatusQueryKey });
    },
    onError: (err: Error) => {
      toast.error("ດາວໂຫຼດ backup ບໍ່ສຳເລັດ", { description: err.message });
    },
  });
}
